import { pBtn } from "components/main.styled";
import styled from "styled-components";
export const PageWrapper = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;   
  @media (max-width: 768px) {
    flex-direction: column;
    height: 100%;

            scrollbar-width: none;
        -ms-overflow-style: none;
        &::-webkit-scrollbar{
          display: none;
        }
  }
`
export const SinglePageContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 70%;
    margin-top: 20px;
    height: fit-content;
    margin: 0px auto; 

    @media (max-width: 1468px) {
        width: 80%;
    }
    @media (max-width: 1068px) {
        width: 100%;
    }
    @media (max-width: 968px) {
        width: 100%;
    }
`
export const TopRightItemContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-radius: 10px; 
    width: 100%;
    height: fit-content; 
`
export const SectionButton = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center; 
` 
export const SectionBtn = styled(pBtn)` 
    background-color: ${props => props.active ? 'var(--themeColor)' : '#ececec'};
    color: ${props => props.active ? 'white' : 'var(--lightThemeFontColor)'};
    margin-right: 10px;  
    &:hover{ 
        background-color: ${props => props.active ? 'var(--themeColor)' : '#d9d9d9ff'};
    };
` 
export const SectionButtonTitle = styled.div`
    padding: 10px 20px;
    cursor: pointer; 
    pointer-events: ${props => props.active || props.disabled ? 'none' : 'auto'};
    border-bottom: ${props => props.active ? '3px solid var(--themeColor)' : '3px solid transparent'};
    color: var(--lightThemeFontColor);
    transition: all 0.4s;
    &:hover{
        border-radius: ${props => props.active ? 'none' : '10px'};
        background-color: #ececec;
        border-bottom: 3px solid transparent;
    };
`
export const RightMainContent = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: fit-content ;
    max-height : 80vh;
    margin-top: 20px;  
    background-color: white;
    overflow-y: scroll;

    
    @media (max-width: 768px) {
        margin-top: 10px;
        height: fit-content;
    }
`
export const SinglePageRight = styled.div`
    display: flex;
    flex-direction: column;
    height: fit-content;
    min-height: 200px;
    max-height: 80%;
    width: 45%;
    padding: 20px; 
    border-radius: 10px; 
    box-shadow: 0 0 10px #ccc;
    background-color: white;

    @media (max-width: 768px) { 
        padding: 20px;
        width: 100%;
        max-height: 600px;
        overflow-y: scroll;
    }
    
`
export const SinglePageLeft = styled.div`
    display: flex;
    flex-direction: column;
    width: ${props => props.fullWidth ? "100%" :"50%"};
    height: fit-content;

    @media (max-width: 768px) {
        width: 100%;
        padding: 10px;
        height: fit-content;
    }
`
export const SinglePageWrap = styled.div`
    display: flex;
    height: calc(100vh - 100px);
    flex-direction: row;
    width: 100%;  
    max-width: 1200px;
    margin-top: ${props => props.addTopMargin ? '20px' : '0px'};
    gap: 20px;

    @media (max-width: 768px) {
        flex-direction: column;
        padding: 10px;
    }
`
export const ComponentPageWrapper = styled.div`
    width: 100%; 
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow-y: scroll;
    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar{
      display: none;
    }
    @media (max-width: 768px) { 
        width: 100vw;
        padding: 10px;
        padding-top: 10px;
    }
`
export const PageHeader = styled.div`
    font-size: 25px;
    font-weight: bold; 
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    color: var(--lightThemeFontColor);
`

export const PageContainerMain = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 60px);
  width: 100vw;
  transition: 0.8s ; 
  padding: 15px;
  gap: 15px;

  @media (max-width: 768px) {
    width: 100%;
    min-width: unset;
            scrollbar-width: none;
        -ms-overflow-style: none;
        &::-webkit-scrollbar{
          display: none;
        }
  }
`
export const UserProfileMain = styled.div`
  margin-left: 0px;
  width: 650px;
  padding: 0px 10px; 
  display: flex;
  flex-direction: column;
  position: relative; 
  height: 100%;

    @media (max-width: 768px) { 
        width: 100vw;
        padding: 0px;

        scrollbar-width: none;
        -ms-overflow-style: none;
        &::-webkit-scrollbar{
          display: none;
        }

    }

`
export const PrayerWallWrap = styled.div`
  width: ${props => props.width};
  transition: 0.8s ;
  overflow: hidden;
`
export const StyledSideBar = styled.div`
  width: fit-content;
  min-width: 300px;
  transition: 1s all ease-in-out;
  overflow: hidden;

    @media (max-width: 768px) {
        display: none;
    }

`